import { NotificationReference } from '@exam-center/graphql';
import {
  AssignmentOutlinedIcon,
  PlaceOutlinedIcon,
  GroupOutlinedIcon,
  InfoOutlinedIcon,
  CalendarTodayIcon,
  NotificationImportantOutlinedIcon,
} from '@shared/components';

export const notificationIconMapper: Record<NotificationReference, JSX.Element> = {
  [NotificationReference.ExamAssignment]: (
    <AssignmentOutlinedIcon
      sx={(theme) => ({ color: theme.palette.primary.main, width: 24, height: 24 })}
    />
  ),
  [NotificationReference.ExamLocationRequest]: (
    <PlaceOutlinedIcon
      sx={(theme) => ({ color: theme.palette.primary.main, width: 24, height: 24 })}
    />
  ),
  [NotificationReference.ExamProctorRequest]: (
    <GroupOutlinedIcon
      sx={(theme) => ({ color: theme.palette.primary.main, width: 24, height: 24 })}
    />
  ),
  [NotificationReference.ExamEvent]: (
    <CalendarTodayIcon
      sx={(theme) => ({ color: theme.palette.primary.main, width: 24, height: 24 })}
    />
  ),
  [NotificationReference.ExamEventAllocation]: (
    <NotificationImportantOutlinedIcon
      sx={(theme) => ({ color: theme.palette.primary.main, width: 24, height: 24 })}
    />
  ),
  [NotificationReference.Other]: (
    <InfoOutlinedIcon
      sx={(theme) => ({ color: theme.palette.primary.main, width: 24, height: 24 })}
    />
  ),
};
